import SuccessMessage from './SuccessMessage';

export default SuccessMessage;
